var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.7 16",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    fill: "#FFFFFF",
    d: "M10.8,0l-2,2l4.6,4.6H0v2.8h13.4L8.8,14l2,2l8-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441_1_",
    fill: "#FFFFFF",
    d: "M10.8,0l-2,2l4.6,4.6H0v2.8h13.4L8.8,14l2,2l8-8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.03d70ac52c8dc668d8b1f8851fdc280a.svg";
export { ForwardRef as ReactComponent };